import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import { User } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/services/alert.service';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-user-change-password',
    templateUrl: './user-change-password.component.html',
    styleUrls: ['./user-change-password.component.sass'],
    standalone: false
})
export class UserChangePasswordComponent implements OnInit {
  
  @Input() user?: User;
  @Output() passwordChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  form: FormGroup;

  newPassword: string;
  oldPassword: string;
  confirmPassword: string;

  capsLock:boolean = false;
  capsLockMessage:string;

  constructor(private fb: FormBuilder, private api: MasterApiService, private alertService: AlertService, private translateService: TranslateService) {
    this.newPassword = '';
    this.oldPassword = '';
    this.confirmPassword = '';
    this.form = this.initFormGroup();
    this.capsLockMessage = this.translateService.instant('common.capsLockIsOn');
  }
  
  ngOnInit(): void {
    this.form = this.initFormGroup();
    document.addEventListener('keyup', (e) => this.capsLock = e.getModifierState('CapsLock'));
  }

  initFormGroup(): FormGroup<any> {
    return this.fb.group({
      currentPassword: [this.oldPassword],
      newPassword: [this.newPassword],
      confirmPassword: [this.confirmPassword, [this.confirmPasswordValidator()] ]
    }, {
      validators: this.checkPasswords
    });
  }

  displayEntity(): string {
    return 'changePassword';
  }

  confirmPasswordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      return (control.value === this.newPassword) ? null : { 'passwordsAreNotEqual': true };
    };
  }

  private checkPasswords(group: AbstractControl): ValidationErrors | null {
    const pass = group.get('newPassword')?.value;
    const confirmPass = group.get('confirmPassword')?.value;

    return pass === confirmPass ? null : { notSame: true };
  }

  async updateEntity(): Promise<void> {
    try {
      const rs = await firstValueFrom(this.api.patchUserResetPassword(this.user!.userName, this.oldPassword, this.newPassword));
      this.passwordChanged.emit(true);
    } catch (error){
      const _error = error as _Error;
      if (_error.error?.message === 'Incorrect password.')
        this.alertService.error(this.translateService.instant('errors.userPasswordIncorrect'));
      else
        this.alertService.error(error as Error);
    }
  }
}

interface _Error {
  error?: { message:string }
}